import { SubscriptionServiceType } from '@/store/contracts/subscriptions/subscriptionServiceType';
import { IStatusHandler } from '@/store/utils/apiResponseHandling';
import { DeepReadonly } from 'vue';

export interface IServerSubscriptionUsage {
  ServiceType: SubscriptionServiceType;
  RecordedDay: Date | string;
  TransactionCount: number;
}

export interface ISubscriptionUsage {
  serviceType: SubscriptionServiceType;
  recordedDay: Date;
  transactionCount: number;
  transactionCountNormalized: number;
}

export enum AggregateUsagePeriodType {
  None = 'None',
  Daily = 'Daily',
  Monthly = 'Monthly'
}

export interface IServerSubscriptionUsageRequest {
  From: Date;
  To: Date;
  ServiceType: SubscriptionServiceType;
  AggregateType: AggregateUsagePeriodType;
}

export interface IServerSubscriptionUsageResponse {
  Usages: IServerSubscriptionUsage[];
}

export interface ITransactionsFilterModel {
  serviceType: SubscriptionServiceType | null;
  from: Date | null;
  to: Date | null;
}

export interface ITransactionsState {
  subscriptionId: string | null;
  dailyUsages: ISubscriptionUsage[];
  monthlyUsages: ISubscriptionUsage[];
  totalUsagesDisplay: string;
  dailyDataPointsUnitsDisplay: string;
  monthlyDataPointsUnitsDisplay: string;
  filterModel: ITransactionsFilterModel;
  transcriptionDailyDividend: number | undefined;
  transcriptionMonthlyDividend: number | undefined;
}

export type TSetSubscriptionId = (subscriptionId) => void;
export type TSetUsages = (dailyUsages: ISubscriptionUsage[], monthlyUsages: ISubscriptionUsage[]) => void;
export type TSetTotalUsagesDisplay = (totalUsagesDisplay: string) => void;
export type TSetDailyDataPointsUnitsDisplay = (dailyDataPointsUnitsDisplay: string) => void;
export type TSetMonthlyDataPointsUnitsDisplay = (monthlyDataPointsUnitsDisplay: string) => void;
export type TSetServiceType = (serviceType: SubscriptionServiceType | null) => void;
export type TSetFrom = (from: Date | null) => void;
export type TSetTo = (to: Date | null) => void;
export type TSetTranscriptionDailyDividend = (transcriptionDailyDividend: number | undefined) => void;
export type TSetTranscriptionMonthlyDividend = (transcriptionMonthlyDividend: number | undefined) => void;
export type TLoadUsages = (handler?: Partial<IStatusHandler<IServerSubscriptionUsageResponse>>) => Promise<void>;

export interface ITransactionsStore {
  state: DeepReadonly<ITransactionsState>;
  setSubscriptionId: TSetSubscriptionId;
  setUsages: TSetUsages;
  setTotalUsagesDisplay: TSetTotalUsagesDisplay;
  setDailyDataPointsUnitsDisplay: TSetDailyDataPointsUnitsDisplay;
  setMonthlyDataPointsUnitsDisplay: TSetMonthlyDataPointsUnitsDisplay;
  setServiceType: TSetServiceType;
  setFrom: TSetFrom;
  setTo: TSetTo;
  setTransriptionDailyDividend: TSetTranscriptionDailyDividend;
  setTransriptionMonthlyDividend: TSetTranscriptionMonthlyDividend;
  loadUsages: TLoadUsages;
}
